import { useState } from 'react';

const useUnits = () => {
  const [units] = useState(() => {
    const storedUnits = localStorage.getItem('units');
    const storedCooperative = localStorage.getItem('cooperative');

    let finalUnits = [];

    if (storedUnits) {
      finalUnits = JSON.parse(storedUnits);
    }

    if (!Array.isArray(finalUnits)) {
      finalUnits = [];
    }

    // Sort units alphabetically by name
    finalUnits.sort((a, b) => {
      const nameA = a.name || '';
      const nameB = b.name || '';
      return nameA.localeCompare(nameB);
    });

    if (storedCooperative) {
      const cooperative = JSON.parse(storedCooperative);
      
      // Remove cooperative from the list if it exists to avoid duplicates
      // Assuming _id is the unique identifier
      if (cooperative._id) {
        finalUnits = finalUnits.filter(unit => unit._id !== cooperative._id);
      }
      
      // Add cooperative to the beginning
      finalUnits.unshift(cooperative);
    }

    return finalUnits;
  });

  return units;
};

export default useUnits;
